export default {
  data() {
    return {
      captchaId: null,
      // если вдруг не подставился токен, боевой по умолчанию
      siteKey: 'ysc1_38whaynsLzeD9rctPrghkfKJWWeB8k9TuEPW1koL8855d17e'
    };
  },
  methods: {
    initCaptcha(callback) {
      if (window.smartCaptcha) {
        const captchaId = window.smartCaptcha.render(this.$refs.smartcaptcha, {
          sitekey: this.siteKey,
          invisible: true,
          callback: (token) => {
            if(callback) {
              callback(token)
            } else {
              this.submitFormAfterCaptchaCheck(token);
            }
          },
        });
        window.smartCaptcha.execute(captchaId);
      }
    }
  },
  mounted() {
    if (conf.smartcaptcha_key) {
      this.siteKey = conf.smartcaptcha_key;
    }
  }
}